import { useSelector } from 'store/hooks'

export const useAuth = () => {
  const { isAuthenticated, isAccountLinked } = useSelector(({ auth }) => auth)

  return {
    isAuthenticated,
    isAccountLinked,
  };
};
